export const Channels = {
  groups: {
    allPatientsCategoryIdChannelGroup: (catId: number) =>
      `chat_gp_patients_category_${catId}`,
    userIdChannelGroup: (userId: number) => `chat_gp_user_${userId}`,
    instCareUserIdChannelGroup: (userId: number) =>
    `insta_care_gp_user_${userId}`,
  },
  
};

export const enum ChannelKeys {
  PatientCategoryChannel = 'PatientCategoryChannel',
  PatientCaregiverChannel = 'PatientCaregiverChannel',
  UserP2PChannel = 'UserP2PChannel',
  UserWatchlistChannel = 'UserWatchlistChannel',
}
